/* Enums */
import { RolesEnum } from '../enums/roles.enum';

export class UsersModel {
  _id: string = undefined;
  access: RolesEnum = RolesEnum.User;
  name: string = '';
  surname: string = '';
  email: string = '';
  password: string = '';
  company: string = '';
  companyName: string = '';
  active: boolean = false;
}
